module.exports = require("@nicky-lenaers/ngx-scroll-to");